import { CartLinesUpdateEvent } from '@shopify/events';

class CartVariantSelector extends HTMLElement {
  connectedCallback() {
    if (!this.boundOnChange) {
      this.boundOnChange = this.onChange.bind(this);
      this.addEventListener('change', this.boundOnChange);
    }
  }

  async onChange(event) {
    const select = event.target;
    if (select.tagName !== 'SELECT') return;

    const oldKey = this.dataset.key;
    const qty = parseInt(this.dataset.qty, 10);
    const newVariantId = select.value;
    
    select.disabled = true;
    select.style.opacity = '0.5';

    try {
      // 1. Add new variant
      const addRes = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: newVariantId, quantity: qty }] })
      });
      
      if (!addRes.ok) throw new Error('Failed to add new variant');

      // 2. Remove old variant, and ask for sections to be updated
      const sectionsToUpdate = document.querySelectorAll('cart-items-component, .cart-totals');
      const sectionIds = [...new Set(Array.from(sectionsToUpdate).map(el => el.dataset.sectionId).filter(Boolean))];
      
      const res = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: { [oldKey]: 0 },
          sections: sectionIds.join(','),
          sections_url: window.location.pathname
        })
      });
      
      if (!res.ok) throw new Error('Failed to update cart');
      
      const cartData = await res.json();

      // Reset state BEFORE morphdom takes over
      select.disabled = false;
      select.style.opacity = '1';

      // 3. Dispatch Shopify standard event so the theme re-renders the cart UI
      const deferredPromise = CartLinesUpdateEvent.createPromise();
      
      this.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'update',
          context: 'cart',
          lines: [{ id: newVariantId, quantity: qty }],
          promise: deferredPromise.promise,
        })
      );

      deferredPromise.resolve({ 
        detail: { 
          sections: cartData.sections, 
          items: cartData.items, 
          itemCount: cartData.item_count,
          source: 'cart-variant-selector',
          didError: false,
        } 
      });

    } catch (err) {
      console.error('Failed to update variant', err);
      if (select) {
        select.disabled = false;
        select.style.opacity = '1';
      }
    }
  }
}

if (!customElements.get('cart-variant-selector')) {
  customElements.define('cart-variant-selector', CartVariantSelector);
}
